/**
 * TadReamk Surveillance Product Data
 *
 * @deprecated - This file uses the legacy structure with hybrid merge approach.
 * MIGRATION PENDING: Will be migrated to JSON translations structure.
 * See: public/locales/en/products/tadreamk-eye.json for the new pattern.
 *
 * For now, this product continues to work using the old translation pattern.
 */

import surveillanceImage from "../../assets/images/products/Trademark Search.webp";
import { APP_CONFIG } from "../../configs/config";

const tadreamkSurveillanceData = {
  id: 4,
  image: surveillanceImage,
  title: "TadReamk Surveillance",
  abstract:
    "Upload a product description once and let Surveillance watch the market for you. We search trading platforms for similar listings and continuously monitor look‑alikes to help ensure no one is copying your original product.",
  ctaUrl: APP_CONFIG.TADREAMK_SURVEILLANCE_URL,
  ctaText: "Start Monitoring",
  primaryFeatureTag: "Product Monitoring",
  imageAlt: "TadReamk Surveillance product similarity monitoring",
  ctaPlacement: "top",
  showOverviewHeading: false,
  description: [
    {
      icon: "🔍",
      title: "Describe it once",
      text: "Paste a crisp product description—or upload metadata—and Surveillance builds a durable search profile that captures the essence of what makes it yours: category, attributes, imagery cues, price bands, and key selling points. Profiles learn over time as you confirm or dismiss results, improving precision without extra effort.",
    },
    {
      icon: "🛒",
      title: "Marketplace scanning",
      text: "We continuously scan major trading platforms and marketplaces at a cadence tuned for your category. Keywords expand semantically to catch evasive phrasing, while image matching (where supported) helps detect near‑duplicates shot from different angles or with minor edits.",
    },
    {
      icon: "🎯",
      title: "Similarity scoring",
      text: "Each hit is scored across textual and visual dimensions with explainable highlights. See exactly which attributes, phrases, or visual cues triggered the match so you can separate harmless inspiration from problematic imitation in seconds.",
    },
    {
      icon: "⏱️",
      title: "Always‑on alerts",
      text: "Create watchlists and receive real‑time or digest alerts as new look‑alikes appear, prices change, sellers relocate, or titles morph to avoid detection. Snooze benign listings; escalate risky ones with a single click.",
    },
    {
      icon: "✅",
      title: "Built for brand protection",
      text: "Organize findings by campaign, annotate screenshots and links, export takedown packets tailored for marketplaces, and keep an audit trail from first detection through resolution. Your team moves from detection to action without switching tools.",
    },
  ],
  testimonial: {
    text: "TadReamk Surveillance caught copycat listings within hours of our launch and kept monitoring variants we hadn’t considered. The explainable highlights made it easy to brief our takedown team and act quickly.",
    author: "Elena Park",
    title: "Head of Brand Protection, NovaGoods",
    avatar:
      "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=150&h=150&fit=crop&crop=face",
  },
};

export default tadreamkSurveillanceData;
